module.exports = __webpack_public_path__ + "media/assets/images/languages/pt-BR-cf7fa5f8c6d0b07b46fd7c477ff97b11.png";